BaseModel = require './base_model.coffee'

class global.AccountSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    max_number_of_regular_users: { default: 0 }
    max_number_of_monitoring_managers: { default: 0 }
    seller_can_edit_templates: { default: true }
    seller_can_see_all_contacts: { default: true }
    seller_can_change_responsability: { default: false }
  }

  isCustom: ->
    @name == 'custom'



// WEBPACK FOOTER //
// ./src/models/account_setting.coffee